<template>
    <main class="ticket-page">
        <section class="ticket-card">

            <div class="ticket-header">
                <h5 class="ticket-title">
                    تیکت‌های {{ type == 'refund' ? 'مرجوعی' : 'پشتیبانی' }} مشتریان
                </h5>
            </div>

            <div class="filter-box">
                <form @submit.prevent="applyFilter" class="filter-form">

                    <div class="filter-field">
                        <label>نام</label>
                        <b-form-input
                            v-model="filter.first_name"
                            placeholder="نام مشتری"
                            :disabled="disabled"
                        />
                    </div>

                    <div class="filter-field">
                        <label>نام خانوادگی</label>
                        <b-form-input
                            v-model="filter.last_name"
                            placeholder="نام خانوادگی مشتری"
                            :disabled="disabled"
                        />
                    </div>

                    <div class="filter-field">
                        <label>شماره موبایل</label>
                        <b-form-input
                            v-model="filter.mobile"
                            placeholder="شماره موبایل"
                            :disabled="disabled"
                        />
                    </div>

                    <div class="filter-field">
                        <label>وضعیت</label>
                        <b-form-select
                            v-model="filter.status"
                            :options="statusOptions"
                            :disabled="disabled"
                        />
                    </div>

                    <div class="filter-actions">
                        <b-button
                            type="button"
                            variant="warning"
                            :disabled="disabled"
                            @click="removeFilter"
                        >
                            برداشتن فیلتر
                        </b-button>

                        <b-button
                            type="submit"
                            variant="primary"
                            :disabled="disabled"
                        >
                            فیلتر
                        </b-button>
                    </div>

                </form>
            </div>

            <div class="ticket-actions">

                <b-table id="main-table" v-if="requests.length" bordered striped hover responsive="sm" :fields="fields"
                    :items="requests" class="ticket-table" thead-class="table-head">

                    <template #cell(index)="data">
                        <span class="row-index">
                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                        </span>
                    </template>

                    <template #cell(customer)="data">
                        <div class="customer-cell" v-if="data.item.customer">
                            {{ data.item.customer.first_name }}
                            {{ data.item.customer.last_name }}
                        </div>

                        <span v-else-if="data.item.customer_id" class="text-muted">
                            مشتری #{{ data.item.customer_id }}
                        </span>

                        <span v-else class="text-muted">—</span>
                    </template>

                    <template #cell(order_items_count)="data">
                        {{ data.item.order_items ? data.item.order_items.length : 0 }} عدد
                    </template>

                    <template #cell(created_at)="data">
                        {{ data.item.created_at | persianDate }}
                    </template>

                    <template #cell(status)="data">
                        <b-badge :variant="statusVariant(data.item.status)">
                            {{ statusLabel(data.item.status) }}
                        </b-badge>
                    </template>

                    <template #cell(actions)="data">
                        <b-button size="sm" variant="outline-primary" @click="goToDetail(data.item)">
                            جزئیات
                        </b-button>
                    </template>

                </b-table>

                <div v-else-if="!disabled" class="empty-state">
                    <span>📭</span>
                    <p>تیکتی برای نمایش وجود ندارد</p>
                </div>

                <div v-if="disabled" class="loading-state">
                    <b-spinner />
                    <span>در حال بارگذاری...</span>
                </div>

                <b-pagination v-if="totalRows > perPage" v-model="currentPage" :total-rows="totalRows"
                    :per-page="perPage" align="center" class="mt-3" @change="loadData" />

            </div>

        </section>
    </main>
</template>

<script>

import configProvider from "@@/core/configProvider";
import mixins from "@@/core/mixins/mixins";

import {
    BTooltip,
    BButton,
    BCard,
    BTable,
    BBadge,
    BPagination,
    BFormInput,
    BFormSelect,
    BSpinner,
} from "bootstrap-vue";

function Filter() {
    this.first_name = "";
    this.last_name = "";
    this.mobile = "";
    this.status = "";
}

export default {

    name: "ticketsList",

    mixins: [mixins],

    components: {
        BTooltip,
        BButton,
        BCard,
        BTable,
        BBadge,
        BPagination,
        BFormInput,
        BFormSelect,
        BSpinner,
    },

    configProvider,

    data() {
        return {

            type: this.$route.query.type,

            requests: [],

            disabled: true,

            currentPage: 1,
            perPage: 20,
            totalRows: 0,

            filter: new Filter(),
            appliedFilter: new Filter(),
        };
    },

    computed: {

        fields() {

            const baseFields = [

                {
                    key: "index",
                    label: "ردیف",
                    thClass: "text-center",
                    tdClass: "text-center",
                },

                {
                    key: "customer",
                    label: "نام مشتری",
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ];

            if (this.type === "refund") {

                baseFields.push({

                    key: "order_items_count",
                    label: "تعداد آیتم مرجوعی",
                    thClass: "text-center",
                    tdClass: "text-center",
                });
            }

            baseFields.push(

                {
                    key: "created_at",
                    label: "تاریخ ثبت",
                    thClass: "text-center",
                    tdClass: "text-center",
                },

                {
                    key: "status",
                    label: "وضعیت",
                    thClass: "text-center",
                    tdClass: "text-center",
                },

                {
                    key: "actions",
                    label: "عملیات",
                    thClass: "text-center",
                    tdClass: "text-center",
                }
            );

            return baseFields;
        },

        statusOptions() {
            return [
                { value: "", text: "همه وضعیت‌ها" },
                { value: "pending", text: "در انتظار" },
                { value: "answered", text: "پاسخ داده شده" },
                { value: "completed", text: "تکمیل شده" },
            ];
        },
    },

    mounted() {

        this.loadData();
    },

    methods: {

        statusLabel(status) {

            const map = {

                new: "جدید",
                pending: "در انتظار",
                answered: "پاسخ داده شده",
                completed: "تکمیل شده",
            };

            return map[status] || status || "—";
        },

        statusVariant(status) {

            const map = {

                new: "secondary",
                pending: "warning",
                answered: "primary",
                completed: "success",
            };

            return map[status] || "secondary";
        },

        applyFilter() {

            this.appliedFilter = { ...this.filter };
            this.loadData(1);
        },

        removeFilter() {

            this.filter = new Filter();
            this.appliedFilter = new Filter();
            this.loadData(1);
        },

        async loadData(page = this.currentPage) {

            this.disabled = true;

            window.scrollTo({ top: 0, behavior: "smooth" });

            try {

                const response = await this.$axios.get("admin/support_requests", {

                    params: {

                        type: this.type,
                        page: page,

                        first_name: this.appliedFilter.first_name || undefined,
                        last_name: this.appliedFilter.last_name || undefined,
                        mobile: this.appliedFilter.mobile || undefined,
                        status: this.appliedFilter.status || undefined,
                    },
                });

                const requests = response.data.data.requests;

                this.requests = requests.data;

                this.currentPage = requests.current_page;
                this.perPage = requests.per_page;
                this.totalRows = requests.total;

            } catch (e) {

                console.error("خطا در دریافت تیکت‌ها", e);

            } finally {

                this.disabled = false;
            }
        },

        goToDetail(item) {
            const routeData = this.$router.resolve({
                path: `/admin/ticket-detail/${item.id}`,
                query: { type: this.type }
            });

            window.open(routeData.href, '_blank');
        }
    },
};
</script>

<style scoped>
.ticket-page {
    direction: rtl;
    padding: 1.5rem;
    font-family: IRANSansWeb, Tahoma, sans-serif;
}

.ticket-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
    padding: 1.5rem;
}

.ticket-header {
    margin-bottom: 1.5rem;
    border-bottom: 2px solid #f0f0f0;
    padding-bottom: 1rem;
}

.ticket-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #222;
    margin-bottom: 0.25rem;
}

.filter-box {
    background: #fafafa;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
}

.filter-form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1rem;
}

.filter-field {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    min-width: 180px;
    flex: 1 1 180px;
}

.filter-field label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #555;
}

.filter-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.ticket-table {
    font-size: 0.9rem;
}

.table-head th {
    background: #f7f8fa;
    color: #444;
    font-weight: 700;
    border-bottom: 2px solid #e0e0e0;
}

.row-index {
    font-weight: 600;
    color: #555;
}

.customer-name {
    font-weight: 600;
    color: #333;
}

.status-badge {
    font-size: 0.8rem;
    padding: 0.3em 0.7em;
    border-radius: 6px;
}

.items-count {
    font-weight: 700;
    color: #d9534f;
}

.date-cell {
    color: #666;
    font-size: 0.85rem;
}

.detail-btn {
    font-size: 0.8rem;
    border-radius: 6px;
}

.empty-state {
    text-align: center;
    padding: 3rem 1rem;
    color: #aaa;
}

.empty-icon {
    font-size: 2.5rem;
    display: block;
    margin-bottom: 0.5rem;
}

.loading-state {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    justify-content: center;
    padding: 2rem;
    color: #666;
}
</style>
